import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat, dateToPlainFormat } from '@/utils'

export interface ReserveContactMail {
  _id: number
  _canSelect: boolean
  userId: string
  name: string
  nameKana: string
  mailAddress: string
  age: string
  collectionNo: string
  displayTitle: string
  displayAuthor: string
  reserveRegistrationTime: string
  reserveExpiration: string
  reserveRegistrationBranchCode: SystemCode
  forwardingBranchCode: SystemCode
}

export function ReserveContactMailFromJSON(json: any): ReserveContactMail {
  return {
    _id: exists(json, '_id') ? json._id : 0,
    _canSelect: exists(json, '_can_select') ? json._can_select : false,
    userId: exists(json, 'user_id') ? json.user_id : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    mailAddress: exists(json, 'mail_address') ? json.mail_address : '',
    age: exists(json, 'age') ? json.age : '',
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    reserveRegistrationTime: exists(json, 'reserve_registration_time')
      ? dateTimeToPlainFormat(json.reserve_registration_time)
      : '',
    reserveExpiration: exists(json, 'reserve_expiration')
      ? dateToPlainFormat(json.reserve_expiration)
      : '',
    reserveRegistrationBranchCode: exists(
      json,
      'reserve_registration_branch_code'
    )
      ? SystemCodeFromJSON(json.reserve_registration_branch_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode()
  }
}
